import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from 'components/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import QuickFilterSearch from 'Search/components/QuickFilterSearch';
import { getPeopleAddresses, removePersonAddress } from 'reducers/SearchReducer';
import PrintsSearch2 from 'Search/components/PrintsSearch2';
import AddressLookup2 from 'components/AddressLookup2';
import Button from '@material-ui/core/Button';
import { savePersonAddress, updatePersonAddress } from 'reducers/SearchReducer';
import Checkbox2 from 'components/Checkbox2';
import XGrid3 from 'components/XGrid3';
import { getFullPermissions } from 'reducers/PermissionsReducer';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { showPersonAddressEdit } from 'reducers/DialogsReducer';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
  wrap: {
    padding: theme.spacing(3),
  },
  gridWrap: {
    width: '100%',
    boxSizing: 'border-box',
    height: 600,
  },
  fileInput: {
    display: 'none',
  },
  form: {
    display: 'flex',
    alignItems: 'center',
    margin: '20px 0 12px',
  },
  filters: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: theme.spacing(2),
    '& > div': {
      marginRight: theme.spacing(2),
    },
  },
  filterWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: 8,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
  },
  addressWidget: {
    width: 550,
    display: 'inline-block',
  },
  address: {
    display: 'flex',
    margin: '24px 0 16px',
  },
  addressActions: {
    marginLeft: 8,
    '& button': {
      marginLeft: 8,
    },
    '& svg': {
      marginRight: 8,
    },
  },
  // panel: {
  //   '& .MuiDataGridPanelFooter-root': {
  //     display: 'none',
  //   },
  // },
}));

const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);

const defaultColumns = [
  { field: 'AddressID', headerName: 'Address ID', width: 150, hide: false },
  { field: 'FullAddressText', headerName: 'Full Address', width: 200, hide: false },
  {
    field: 'IsPrimary',
    headerName: 'Is Primary',
    width: 100,
    format: 'bool',
    renderCell: bool,
    hide: false,
  },
  {
    field: 'Country',
    headerName: 'Country',
    width: 125,
    hide: false,
  },
  {
    field: 'State',
    headerName: 'State',
    width: 100,
    hide: false,
  },
  {
    field: 'StreetName',
    headerName: 'StreetName',
    width: 150,
    hide: false,
  },
  {
    field: 'BldgType',
    headerName: 'BldgType',
    width: 150,
    hide: false,
  },
  {
    field: 'BldgIdentifier',
    headerName: 'Bldg Identifier',
    width: 150,
    hide: false,
  },
  {
    field: 'AddressNumberPrefix',
    headerName: 'Prefix',
    width: 150,
    hide: false,
  },
  {
    field: 'AddressNumber',
    headerName: 'Number',
    width: 150,
    hide: false,
  },
  {
    field: 'AddressNumberSuffix',
    headerName: 'Suffix',
    width: 150,
    hide: false,
  },
  {
    field: 'PreDirection',
    headerName: 'Pre Direction',
    width: 150,
    hide: false,
  },
  {
    field: 'City',
    headerName: 'City',
    width: 150,
    hide: false,
  },
  {
    field: 'PostalCode',
    headerName: 'Postal Code',
    width: 150,
    hide: false,
  },
  {
    field: 'PostalCodeExtension',
    headerName: 'Extension',
    width: 150,
    hide: false,
  },
  {
    field: 'FloorType',
    headerName: 'Floor Type',
    width: 150,
    hide: false,
  },
  {
    field: 'FloorIdentifier',
    headerName: 'Floor Identifier',
    width: 150,
    hide: false,
  },
  {
    field: 'UnitType',
    headerName: 'Unit Type',
    width: 150,
    hide: false,
  },
  {
    field: 'Unit Identifier',
    headerName: 'Unit Identifier',
    width: 150,
    hide: false,
  },
];

const EDIT_MODE_ADD = 'add';
const EDIT_MODE_IS_PRIMARY = 'isPrimary';

function Addresses(props) {
  const { ptsPersonID, dataUpdate } = props;
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selection, setSelection] = useState(null);
  const [columns, setColumns] = useState(defaultColumns);
  const [editing, setEditing] = useState(false);
  const [editMode, setEditMode] = useState(null);
  const [address, setAddress] = useState(null);
  const [IsPrimary, setIsPrimary] = useState(false);
  const [editMenuAnchor, setEditMenuAnchor] = useState(null);
  const mountedRef = useRef(true);
  const peoplePerms = getFullPermissions('globals', 'People', 'any');
  const addressPerms = getFullPermissions('globals', 'Addresses', 'any');
  const canEditAddress = Boolean(peoplePerms.Edit) && Boolean(addressPerms.Edit);
  const canEditPerson = peoplePerms.Edit;

  useEffect(() => {
    ptsPersonID && getData();
  }, []);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (!dataUpdate || dataUpdate.type !== 'Address') return;
    getData();
    // eslint-disable-next-line
  }, [dataUpdate]);

  const getData = async () => {
    try {
      const data = await getPeopleAddresses(ptsPersonID);
      if (!mountedRef.current) return;
      setRows(processData(data.data));
      setFilteredRows(processData(data.data));
      setLoaded(true);
    } catch (err) {
      props.handleError(err);
    }
  };

  const processData = (data) => {
    return data.map((row) => {
      const City = row.Address[0]?.City?.CityDescription;
      return {
        id: row.ptsAddressID,
        IsPrimary: row.IsPrimary,
        ...row.Address[0],
        City,
      };
    });
  };

  const onAddClick = () => {
    setEditMode(EDIT_MODE_ADD);
    setEditing(true);
    setAddress(null);
    setIsPrimary(false);
    setSelection(null);
  };

  const onEditClick = (event) => {
    setEditMenuAnchor(event.currentTarget);
  };

  const handleEditMenuClose = () => {
    setEditMenuAnchor(null);
  };

  const onEditAddressClick = () => {
    handleEditMenuClose();
    props.showPersonAddressEdit(selection);
  };

  const onEditIsPrimaryClick = () => {
    handleEditMenuClose();
    const selectedAddress = rows.find((row) => row.ptsAddressID === selection);
    setAddress(selectedAddress);
    setIsPrimary(selectedAddress.IsPrimary);
    setEditMode(EDIT_MODE_IS_PRIMARY);
    setEditing(true);
  };

  const onDeleteClick = async () => {
    if (!window.confirm('Are you sure you want to delete selected address?')) return;
    props.showSpinner();
    try {
      await removePersonAddress({ ptsPersonID, ptsAddressID: selection });
      await getData();
      setSelection(null);
    } catch (err) {
      props.handleError(err, 'Error, Unable to remove address');
    } finally {
      props.hideSpinner();
    }
  };

  const onAddAddress = (address) => {
    setAddress(address);
  };

  const clearPlace = () => {
    setAddress(null);
  };

  const onCloseEditing = () => {
    setEditing(false);
    setEditMode(null);
    setAddress(null);
  };

  const save = async () => {
    const data = {
      ptsPersonID,
      ptsAddressID: address.ptsAddressID,
      IsPrimary,
    };
    props.showSpinner();
    try {
      if (editMode === EDIT_MODE_IS_PRIMARY) {
        await updatePersonAddress(data);
      } else {
        await savePersonAddress(data);
      }
      await getData();
      setAddress(null);
      setEditing(false);
      setEditMode(null);
    } catch (err) {
      props.handleError(err);
    } finally {
      props.hideSpinner();
    }
  };

  const renderIsPrimary = () => {
    const onChange = () => setIsPrimary(!IsPrimary);
    return <Checkbox2 checked={IsPrimary} onChange={onChange} label="Is Primary" />;
  };

  const renderActions = () => {
    return (
      <div className={classes.addressActions}>
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          disabled={!address || !canEditPerson}>
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={onCloseEditing}>
          <CloseIcon /> Close
        </Button>
      </div>
    );
  };

  const renderEditingForm = () => {
    if (editMode === EDIT_MODE_IS_PRIMARY) {
      return (
        <div className={classes.form}>
          <TextField
            autoComplete="hidden"
            size="small"
            label="Address"
            variant="outlined"
            value={address?.FullAddressText || ''}
            fullWidth
            className={classes.addressWidget}
            disabled
          />
          {renderIsPrimary()}
        </div>
      );
    }

    return (
      <div className={classes.form}>
        <AddressLookup2
          className={classes.addressWidget}
          ptsPlaces={false}
          ptsAddresses={true}
          googleAddresses={false}
          onPlaceValueSet={onAddAddress}
          onAddressValueSet={onAddAddress}
          onReset={clearPlace}
          label="Search Address"
          compact="true"
        />
        {renderIsPrimary()}
      </div>
    );
  };

  return (
    <div className={classes.wrap}>
      <div className={classes.filterWrap}>
        {editing && (
          <>
            {renderEditingForm()}
            <div>{renderActions()}</div>
          </>
        )}
        {!editing && (
          <>
            <div className={classes.filterWrap}>
              <QuickFilterSearch rows={rows} columns={columns} setFilteredRows={setFilteredRows} />
            </div>
            <div className={classes.actions}>
              <PrintsSearch2 title="Person Addresses" data={filteredRows} cols={columns} />
              <Tooltip title="Add Address">
                <span>
                  <Fab
                    className="ml-2"
                    size="small"
                    color="secondary"
                    onClick={onAddClick}
                    disabled={!canEditPerson}>
                    <AddIcon />
                  </Fab>
                </span>
              </Tooltip>
              {selection && (
                <>
                  <Tooltip title="Edit Address">
                    <Fab
                      className="ml-2"
                      size="small"
                      color="secondary"
                      onClick={onEditClick}
                      disabled={!canEditAddress}>
                      <EditIcon />
                    </Fab>
                  </Tooltip>
                  <Menu
                    anchorEl={editMenuAnchor}
                    open={Boolean(editMenuAnchor)}
                    onClose={handleEditMenuClose}
                    keepMounted>
                    <MenuItem onClick={onEditIsPrimaryClick}>Manage Primary</MenuItem>
                    <MenuItem onClick={onEditAddressClick}>Open Address Record</MenuItem>
                  </Menu>
                  <Tooltip title="Delete Address" className="ml-2">
                    <Fab
                      size="small"
                      color="secondary"
                      onClick={onDeleteClick}
                      disabled={!canEditPerson}>
                      <DeleteIcon />
                    </Fab>
                  </Tooltip>
                </>
              )}
            </div>
          </>
        )}
      </div>
      <XGrid3
        name="PeopleAddresses"
        columns={columns}
        setColumns={setColumns}
        rows={filteredRows}
        loading={!loaded}
        setSelection={setSelection}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  dataUpdate: state.dataUpdate,
});

export default connect(mapStateToProps, {
  handleError,
  showSpinner,
  hideSpinner,
  showPersonAddressEdit,
})(Addresses);
